type HubEnv = 'prod' | 'staging';

const PROD_SUPABASE_URL = 'https://wvfkygtwsdpumymottzn.supabase.co';
const PROD_SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Ind2Zmt5Z3R3c2RwdW15bW90dHpuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTgzMzkyNjQsImV4cCI6MjA3MzkxNTI2NH0.TVTW0J5M269JCqnf7G9BQBbsC7lI5lDl3dg5qdeK94A';
const DEFAULT_STORE_URL = 'https://rvlry.app';

const iosStoreUrl = import.meta.env.VITE_APP_STORE_URL ?? DEFAULT_STORE_URL;
const androidStoreUrl = import.meta.env.VITE_PLAY_STORE_URL ?? DEFAULT_STORE_URL;
const hasIosStoreLink = iosStoreUrl !== DEFAULT_STORE_URL;
const hasAndroidStoreLink = androidStoreUrl !== DEFAULT_STORE_URL;

const LS_ENV_KEY = 'rvlry.hub.env';
const LS_STAGING_URL_KEY = 'rvlry.hub.staging.supabaseUrl';
const LS_STAGING_ANON_KEY = 'rvlry.hub.staging.supabaseAnonKey';

function safeLocalStorageGet(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function resolveSelectedEnv(): HubEnv {
  try {
    const params = new URLSearchParams(window.location.search);
    const env = params.get('env');
    if (env === 'staging') return 'staging';
    if (env === 'prod') return 'prod';
  } catch {
    // ignore
  }
  const stored = safeLocalStorageGet(LS_ENV_KEY);
  return stored === 'staging' ? 'staging' : 'prod';
}

function resolveStagingCreds(): { url: string; anonKey: string } | null {
  const url = import.meta.env.VITE_SUPABASE_URL_STAGING ?? safeLocalStorageGet(LS_STAGING_URL_KEY) ?? '';
  const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY_STAGING ?? safeLocalStorageGet(LS_STAGING_ANON_KEY) ?? '';
  if (!url || !anonKey) return null;
  return { url, anonKey };
}

const selectedEnv = (() => {
  const explicit = resolveSelectedEnv();
  if (explicit !== 'prod') return explicit;
  const hasBundledStagingCreds = Boolean(
    import.meta.env.DEV &&
    import.meta.env.VITE_SUPABASE_URL_STAGING &&
    import.meta.env.VITE_SUPABASE_ANON_KEY_STAGING,
  );
  return hasBundledStagingCreds ? 'staging' : explicit;
})();
const stagingCreds = resolveStagingCreds();
const activeEnv: HubEnv = selectedEnv === 'staging' && stagingCreds ? 'staging' : 'prod';
const supabaseUrl = activeEnv === 'staging'
  ? stagingCreds!.url
  : (import.meta.env.VITE_SUPABASE_URL ?? PROD_SUPABASE_URL);
const supabaseAnonKey = activeEnv === 'staging'
  ? stagingCreds!.anonKey
  : (import.meta.env.VITE_SUPABASE_ANON_KEY ?? PROD_SUPABASE_ANON_KEY);

export const config = {
  hubSelectedEnv: selectedEnv,
  hubActiveEnv: activeEnv,
  hubHasStagingCreds: !!stagingCreds,
  hubLocalStorageKeys: {
    env: LS_ENV_KEY,
    stagingSupabaseUrl: LS_STAGING_URL_KEY,
    stagingSupabaseAnonKey: LS_STAGING_ANON_KEY,
  },
  supabaseUrl,
  supabaseAnonKey,
  iosStoreUrl,
  androidStoreUrl,
  hasIosStoreLink,
  hasAndroidStoreLink,
  hasStoreLinks: hasIosStoreLink || hasAndroidStoreLink,
  appDeepLinkBase: import.meta.env.VITE_APP_LINK_BASE ?? 'rvlry://join/',
};
